import { render, staticRenderFns } from "./SchoolInfoModal__Style#Drawer.vue?vue&type=template&id=4fbb51ca&scoped=true"
import script from "./SchoolInfoModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./SchoolInfoModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfoModal__Style#Drawer.vue?vue&type=style&index=0&id=4fbb51ca&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb51ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbb51ca')) {
      api.createRecord('4fbb51ca', component.options)
    } else {
      api.reload('4fbb51ca', component.options)
    }
    module.hot.accept("./SchoolInfoModal__Style#Drawer.vue?vue&type=template&id=4fbb51ca&scoped=true", function () {
      api.rerender('4fbb51ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolInfo/modules/SchoolInfoModal__Style#Drawer.vue"
export default component.exports